export const TypeDocument = {
    es: [
        {
            "label": "Cédula de ciudadanía",
            "code": "CC",
            "flag": "Documento de identificación para ciudadanos colombianos mayores de edad.",
            "id": 0
        },
        {
            "label": "Tarjeta de identidad",
            "code": "TI",
            "flag": "Documento de identificación para ciudadanos colombianos menores de edad.",
            "id": 2

        },
        {
            "label": "Cédula de extranjería",
            "code": "CE",
            "flag": "Documento de identificación para extranjeros residentes en Colombia.",
            "id": 1
        },
        {
            "label": "Pasaporte",
            "code": "PAS",
            "flag": "Documento de viaje emitido por un país para permitir a sus ciudadanos viajar internacionalmente.",
            "id": 4
        },
        {
            "label": "Registro civil de nacimiento",
            "code": "RC",
            "flag": "Documento de identificación para menores de edad registrado en Colombia.",

        },
        {
            "label": "NIT",
            "code": "NIT",
            "flag": "Número de Identificación Tributaria para personas jurídicas y algunos independientes.",
            "id": 3
        },
        {
            "label": "Permiso Especial de Permanencia",
            "code": "PEP",
            "flag": "Documento otorgado a ciertos extranjeros en Colombia para legalizar su estancia temporal.",
            "id": 6
        }
    ]
}
